import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterP2pLeaderboard } from "@givebutter/widgets-core";
//#region src/components/GivebutterP2pLeaderboard.tsx
const GivebutterP2pLeaderboard$1 = createLitComponent({
	elementClass: GivebutterP2pLeaderboard,
	tagName: "givebutter-p2p-leaderboard"
});
//#endregion
export { GivebutterP2pLeaderboard$1 as GivebutterP2pLeaderboard };
